import { render, staticRenderFns } from "./OtherCashesList.vue?vue&type=template&id=7035c1ac"
import script from "./OtherCashesList.vue?vue&type=script&lang=js"
export * from "./OtherCashesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports